<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <strong>{{ $t('components.documentsList') }}</strong>
              </CCol>


            </CRow>

            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker

                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>

            </CRow>

          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab :title="$t('components.receiveCheque')" active>
                <CDataTable
                    :items="items_receive"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    sorter
                    pagination
                >
                  <template #row="{item}">

                    <td style="text-align: center">
                      <p >{{ item.row_id + 1 }}</p>

                    </td>

                  </template>
                  <template #createdAt="{item}">

                    <td>
                      <p >{{ item.createdAt }}</p>

                    </td>

                  </template>

                  <template #price="{item}">

                    <td>
                      <p>{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")}}</p>

                    </td>


                  </template>
                  <template #customer="{item}">

                    <td>
                      <p >{{ item.partyName }}</p>

                    </td>

                  </template>

                  <template #user="{item}">

                    <td>
                      <p >{{ item.createdBy }}</p>

                    </td>

                  </template>


                  <template #operation="{item,index}">
                    <td>
                      <CButton v-if="item.statusId !=0"
                               color="primary"
                               variant="outline"
                               square
                               :title="$t('buttons.returnDocument')"
                               size="sm"
                               @click="goReturnDocument(item,index)"
                      >
                        <CIcon name="cilTransfer"/>
                      </CButton>

                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.show')"
                          size="sm"
                          @click="goShowDocument(item)"
                      >
                        <CIcon name="cil-speedometer"/>
                      </CButton>

                      <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                               class="m-1"
                               color="primary"
                               variant="outline"
                               square
                               :title="$t('buttons.refer')"
                               size="sm"
                               @click="AddRefer(item)"
                      >
                        <CIcon name="cilShare"/>
                      </CButton>

                      <CButton v-if="item.statusId ==0"
                               class="m-1"
                               color="primary"
                               square
                               size="sm"
                               :title="$t('buttons.finalize')"
                               @click="Finalize(item)"
                      >
                        <CIcon name="cil-https"/>
                      </CButton>
                    </td>
                  </template>

                </CDataTable>

              </CTab>
              <CTab :title="$t('components.payCheque')">
                <CDataTable
                    :items="items_pay"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    sorter
                    :sorter-value="{column:'recId',asc:false}"
                    pagination
                >
                  <template #row="{item}">

                    <td style="text-align: center">
                      <p >{{ item.row_id + 1 }}</p>

                    </td>

                  </template>
                  <template #createdAt="{item}">

                    <td>
                      <p >{{ item.createdAt }}</p>

                    </td>

                  </template>

                  <template #warehouse="{item}">
                    <td>
                      <p >{{ item.placeName }}</p>

                    </td>

                  </template>
                  <template #price="{item}">

                    <td>
                      <p >{{ item.totalPrice }}</p>

                    </td>


                  </template>
                  <template #customer="{item}">

                    <td>
                      <p >{{ item.partyName }}</p>

                    </td>

                  </template>
                  <template #toziKonande="{item}">

                    <td>
                      <p v-if="item.toziKonande!=null" >{{ item.toziKonande }}</p>

                    </td>

                  </template>
                  <template #user="{item}">

                    <td>
                      <p >{{ item.createdBy }}</p>

                    </td>

                  </template>


                  <template #operation="{item}">
                    <td >
                      <CButton v-if="item.statusId !=0"
                               color="primary"
                               variant="outline"
                               square
                               :title="$t('buttons.returnDocument')"
                               size="sm"
                               @click="goReturnDocument(item)"
                      >
                        <CIcon name="cilTransfer"/>
                      </CButton>
                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.show')"
                          size="sm"
                          @click="goShowDocument(item)"
                      >
                        <CIcon name="cil-speedometer"/>
                      </CButton>
                      <CButton
                          class="m-1"
                          color="success"
                          square
                          size="sm"
                          :title="$t('buttons.print')"
                          @click="goPrintDocument(item)"
                      >
                        <CIcon name="cil-print"/>
                      </CButton>
                      <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                               class="m-1"
                               color="primary"
                               variant="outline"
                               square
                               :title="$t('buttons.refer')"
                               size="sm"
                               @click="AddRefer(item)"
                      >
                        <CIcon name="cilShare"/>
                      </CButton>

                      <CButton v-if="item.statusId ==0"
                               class="m-1"
                               color="primary"
                               square
                               size="sm"
                               :title="$t('buttons.finalize')"
                               @click="Finalize(item)"
                      >
                        <CIcon name="cil-https"/>
                      </CButton>

                      <CButton
                          class="m-1"
                          color="primary"
                          square
                          size="sm"
                          :label="$t('sendToCustomer')"
                          @click="send_to_customer(item)"
                      >{{$t('sendToCustomer')}}
                      </CButton>
                    </td>
                  </template>


                </CDataTable>

              </CTab>

            </CTabs>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    'test-dynamic': () => import('../documents/PrintDocument'),

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      file: '',

      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,

      items_pay: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      items_receive: items_data.map((item, row_id) => {

        return {...item, row_id}

      }),

      fields: [
        {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
        {key: 'createdAt', label: this.$t('tables.date'), _style: 'width:15%'},
        {key: 'checkDate', label: this.$t('tables.pass_date'), _style: 'width:15%'},
        {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:2%'},
        // {key: 'انبار', _style: 'width:10%'},
        {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'user', label: this.$t('tables.receiver'), _style: 'width:15%'},
        {key: 'ownerName', label: this.$t('tables.ownerName'), _style: 'width:15%'},
        {key: 'serial', label: this.$t('tables.serial'), _style: 'width:15%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],


      status_form: 0,
      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  }, mounted() {

    this.start_date = moment().format('YYYY-MM-01');
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];


    this.get_all_docs();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_docs();

    },
    'start_date': function () {
      this.get_all_docs();

    },
    'end_date': function () {
      this.get_all_docs();
    }
  },
  methods: {
    get_all_docs() {
      this.get_lists_receive();
      // this.get_lists_pay();

    },


    get_lists_receive() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "GetChequeInfo";
      formData.append("MasterId", 0);
      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_receive = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_pay() {

      var self = this;


      const formData = new FormData();

      var url = "GetDocsByParams";
      formData.append("docType", 3);
      if (self.$route.params.person_id != null) {
        formData.append("PersonId", self.$route.params.person_id);

      } else {
        formData.append("PersonId", 0);

      }

      // formData.append("id", 3);

      formData.append("FirstDate", self.start_date);
      formData.append("SecondDate", self.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_sell = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    Finalize(item) {
      var self = this;


      const formData = new FormData();

      var url = "AddFactorToFinal";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    send_to_customer(item) {
      var self = this;


      const formData = new FormData();

      var url = "SendFactorToTelegramBoth";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusId = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goReturnDocument(item) {
      this.$router.push({
        path: '/dashboard/documents/return/' + item.recId + "/false",
        params: {passed_data: "salam hamidddd"}
      });

    },
    goShowDocument(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.recId});

    },
    goPrintDocument(item) {
      bus.$emit("print_confirm", item.recId);

    },


  },

}

</script>
